import React, { Component } from 'react';
import { Repeater, ItemContainer } from '../../../../library/repeater';
import MyPageKidInfoPop from '../../../mypage/mypagekidinfo/MyPageKidInfoPop';
import ChildDetail from './ChildDetail';
import DesktopLayerPopup from '../../../common/DesktopLayerPopup';
import MyPageInjector from '../../../mypage/mypagemain/MyPageInjector';

class WinkPaidStudyChildSelect extends Component {
    constructor(props) {
        super(props);
        this.onClickAddStudent = this.onClickAddStudent.bind(this);
    }

    onClickAddStudent(e) {
        e.preventDefault();
        let newProps = { ...this.props };
        delete newProps.studentInfo;

        DesktopLayerPopup.modal(<MyPageKidInfoPop {...newProps} />);

        return false;
    }

    render() {
        const { availableStudents } = this.props;

        return (
            <section>
                <hgroup>
                    <h1 className="no-line title">윙크 학습을 할 자녀를 선택해 주세요.</h1>
                </hgroup>
                <div className="dragitem-wrap">
                    <div className="dragitem">
                        <Repeater arrayData={availableStudents} propName="childInfo" elementName="div" className="div">
                            <ItemContainer>
                                <ChildDetail handleClick={this.props.checkChildSubject} {...this.props} />
                            </ItemContainer>
                        </Repeater>
                        {/*TODO - 아이추가*/}
                        <a onClick={this.onClickAddStudent} className="item-add not-move" id="paidstudy-add-child">
                            <span>아이등록</span>
                        </a>
                    </div>
                </div>
            </section>
        );
    }
}

export default MyPageInjector()(WinkPaidStudyChildSelect);
